module.exports = __webpack_public_path__ + "img/eat_out_09.8f6094dd.jpg";